// avstemming-shell-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avcs.common.cancel': 'Cancel',
  'avcs.common.open': 'Open',
  'avcs.common.requestDocs': 'Request documentation',
  'avcs.common.ofCount': '{done} of {total}',
  'avcs.common.unknown': 'Unknown',
  'avcs.common.version': 'Version {version}',
  'avcs.common.docsMissing': '{count} documents missing',
  'avcs.common.reset': 'Reset',
  'avcs.common.status': 'Status',
  'avcs.common.period': 'Period',
  'avcs.common.responsible': 'Responsible',
  'avcs.common.deadline': 'Deadline',
  'avcs.common.client': 'Client',
  'avcs.common.deviation': 'Deviation',
  'avcs.common.deviations': '{count} deviations',
  'avcs.common.notRelevant': 'Not relevant',
  'avcs.common.notStarted': 'Not started',
  'avcs.common.wholePeriodWord': 'The whole period',
  'avcs.area.bank': 'Bank',
  'avcs.area.receivables': 'Trade receivables',
  'avcs.area.payables': 'Trade payables',
  'avcs.area.payroll': 'Payroll',
  'avcs.area.vat': 'VAT',
  'avcs.area.tax': 'Tax and public duties',
  'avcs.area.assets': 'Assets',
  'avcs.area.loans': 'Loans and debt',
  'avcs.area.equity': 'Equity',
  'avcs.area.other': 'Other balance sheet',
  'avcs.area.periodControls': 'Period controls',
  'avcs.reason.externalBalanceMissing': 'External balance is missing.',
  'avcs.reason.unexplainedDifference': 'The difference is not explained.',
  'avcs.reason.explanationMissingReason': 'An explanation is missing a justification.',
  'avcs.reason.documentationMissing': 'Documentation is missing: attach a voucher or write a note.',
  'avcs.reason.lineAssessmentMissingComment': 'An assessment of a bank line is missing the justification it requires.',
  'avcs.reason.checklistIncomplete': 'One or more points in the professional checklist have not been assessed.',
  'avcs.reason.criticalDeviationUnexplained': 'A critical point is marked as a deviation without a justification.',
  'avcs.rollforward.opening': 'Opening balance',
  'avcs.rollforward.movement': 'Movement in the period',
  'avcs.rollforward.closing': 'Closing balance',
  'avcs.rollforward.drift': 'Not explained by opening balance and movement',
  'avcs.kontroll.noDeadline': 'No review deadline',
  'avcs.kontroll.overdueOne': 'Review deadline {date} · overdue by {days} day',
  'avcs.kontroll.overdueMany': 'Review deadline {date} · overdue by {days} days',
  'avcs.kontroll.today': 'Review deadline today',
  'avcs.kontroll.inOne': 'Review deadline {date} · in {days} day',
  'avcs.kontroll.inMany': 'Review deadline {date} · in {days} days',
  'avcs.kontroll.bannerTitle': 'Review of {scope} · {period}',
  'avcs.kontroll.basisAt': ' · data basis as of {time}',
  'avcs.kontroll.performedBy': 'Performed by {name}',
  'avcs.kontroll.deviationsInBasis': '{count} deviations in the basis',
  'avcs.kontroll.progress': 'Review progress: {done} of {total} points',
  'avcs.kontroll.reconProgress': 'Reconciliation: {progress} % done',
  'avcs.kontroll.waitingDocs': 'Waiting for documentation: {request}',
  'avcs.kontroll.waitingDue': ' · deadline {date}',
  'avcs.kontroll.sendRequest': 'Send request',
  'avcs.kontroll.whatMissing': 'What is missing',
  'avcs.kontroll.whatMissingHint': 'The review is kept open, but cannot be approved until the request has been answered.',
  'avcs.kontroll.whatMissingPlaceholder': 'Describe which documentation you need to be able to vouch for the work',
  'avcs.kontroll.deadlineOptional': 'Deadline (optional)',
  'avcs.kontroll.summaryTitle': 'Review summary: {scope}',
  'avcs.kontroll.performedByLabel': 'Performed by',
  'avcs.kontroll.versionLabel': 'Version',
  'avcs.kontroll.dataBasis': 'Data basis',
  'avcs.kontroll.asOf': 'As of {time}',
  'avcs.kontroll.materiality': 'Materiality threshold',
  'avcs.kontroll.notSet': 'Not set',
  'avcs.kontroll.criticalDeviations': 'Critical deviations',
  'avcs.kontroll.missingDocs': 'Missing documentation',
  'avcs.kontroll.remainingRisk': 'Remaining risk',
  'avcs.kontroll.notDescribed': 'Not described yet.',
  'avcs.kontroll.approvedByLabel': 'Approved by',
  'avcs.kontroll.periodContext': 'Period context: {progress} % done · {avvik} deviations · {mangler} documents missing in total (does not block this review)',
  'avcs.kontroll.noneOpen': 'No review is open.',
  'avcs.kontroll.blockPerformer': 'You performed this work and cannot review it.',
  'avcs.kontroll.blockUnassessed': '{count} review points have not been assessed.',
  'avcs.kontroll.blockMustFixOne': '{count} point is marked "Must be corrected".',
  'avcs.kontroll.blockMustFixMany': '{count} points are marked "Must be corrected".',
  'avcs.kontroll.blockNoteEmpty': 'A remark has no text.',
  'avcs.kontroll.blockDocsRequest': 'The document request has not been answered.',
  'avcs.kontroll.blockConclusion': 'The review has deviations or remarks. The conclusion must then be written.',
  'avcs.kontroll.blockAreaOpen': 'The area {area} has not been fully reviewed.',
  'avcs.kontroll.blockAreasOpen': '{count} areas in the period have not been fully reviewed.',
  'avcs.kontroll.pointsAssessed': '{done} of {total} points assessed',
  'avcs.kontroll.pointsBreakdown': '{ok} OK · {notes} remark · {mustFix} to correct',
  'avcs.kontroll.performerNotice': 'You performed this work, and therefore cannot review it. A review requires another person.',
  'avcs.kontroll.changedAfterNotice': 'The accounts have been changed since the review was approved. The approval stands, but it no longer rests on the figures that apply now.',
  'avcs.kontroll.returnedNotice': 'Returned to the performer: {note}',
  'avcs.kontroll.points': 'Review points',
  'avcs.kontroll.noPoints': 'The review has no points.',
  'avcs.kontroll.approvedBy': 'Approved by {name}. {conclusion}',
  'avcs.kontroll.reviewerConclusion': 'Reviewer\'s conclusion',
  'avcs.kontroll.conclusionPlaceholder': 'What is the approval based on?',
  'avcs.kontroll.reopenPrompt': 'Why is the review being reopened?',
  'avcs.kontroll.reopen': 'Reopen the review',
  'avcs.kontroll.markDocsReceived': 'Mark the documentation as received',
  'avcs.kontroll.returnPlaceholder': 'What needs to be corrected?',
  'avcs.kontroll.returnToPerformer': 'Return to the performer',
  'avcs.kontroll.approveScope': 'Approve {scope}',
  'avcs.kontroll.approvePeriod': 'Approve the period',
  'avcs.kontroll.history': 'History',
  'avcs.cell.reconciled': 'Reconciled',
  'avcs.cell.notChecked': 'Not checked',
  'avcs.matrix.noResponsible': 'No one responsible',
  'avcs.overall.done': 'Done',
  'avcs.overall.working': 'In progress',
  'avcs.matrix.sortBy': 'Sort by {name}',
  'avcs.matrix.noClients': 'No clients match the filters.',
  'avcs.matrix.progress': 'Progress',
  'avcs.matrix.org': 'Org. {org}',
  'avcs.matrix.noOrg': 'No org. no.',
  'avcs.matrix.openAreaFor': 'Open {area} for {client}',
  'avcs.matrix.openFolder': 'Open the folder',
  'avcs.matrix.noTasks': 'No open reconciliation tasks match the filters.',
  'avcs.activity.periodOpened': 'opened the period',
  'avcs.activity.periodLocked': 'locked the period',
  'avcs.activity.periodReopenedReason': 'reopened the period – {reason}',
  'avcs.activity.periodReopened': 'reopened the period',
  'avcs.activity.accountUpdatedStatus': 'updated account {account} ({status})',
  'avcs.activity.accountUpdated': 'updated account {account}',
  'avcs.activity.basisChanged': 'booked balance on {account} changed after reconciliation',
  'avcs.activity.commentAdded': 'wrote a comment',
  'avcs.activity.documentAddedOnAccount': 'attached {file} to account {account}',
  'avcs.activity.documentAdded': 'attached {file}',
  'avcs.activity.aDocument': 'a document',
  'avcs.activity.documentRemoved': 'removed {file}',
  'avcs.activity.requestCreated': 'asked the client for {subject}',
  'avcs.activity.documentation': 'documentation',
  'avcs.activity.requestUpdated': 'updated a client request',
  'avcs.activity.none': 'No activity recorded in this period yet.',
  'avcs.comments.none': 'No comments yet.',
  'avcs.comments.visibleToClient': 'Visible to the client',
  'avcs.comments.internal': 'Internal',
  'avcs.comments.placeholder': 'Write a comment',
  'avcs.comments.add': 'Add',
  'avcs.panel.tab.documents': 'Documents',
  'avcs.panel.tab.review': 'Review',
  'avcs.panel.tab.comments': 'Comments',
  'avcs.panel.tab.activity': 'Activity',
  'avcs.panel.tab.requests': 'Requests',
  'avcs.panel.notSent': 'The period has not been sent for review yet. "Send the whole period for review" is at the top.',
  'avcs.panel.controlDue': ' · deadline {date}',
  'avcs.panel.controlPerformedBy': ' · performed by {name}',
  'avcs.panel.openInReview': 'Open in the review workspace',
  'avcs.panel.approvalNote': 'Approval and return happen in the review workspace. Someone other than the person who performed the work must approve it.',
  'avcs.panel.show': 'Show panel',
  'avcs.panel.showing': 'Showing {account}',
  'avcs.panel.hide': 'Hide panel',
  'avcs.portfolio.title': 'Reconciliation',
  'avcs.portfolio.subtitle': 'Follow up reconciliations across your clients.',
  'avcs.portfolio.viewMatrix': 'Matrix',
  'avcs.portfolio.viewTasks': 'Task list',
  'avcs.portfolio.refresh': 'Refresh',
  'avcs.portfolio.searchClient': 'Search for a client',
  'avcs.portfolio.allResponsible': 'All responsible',
  'avcs.portfolio.allStatuses': 'All statuses',
  'avcs.portfolio.allDeadlines': 'All deadlines',
  'avcs.portfolio.next7': 'Next 7 days',
  'avcs.portfolio.deadlinePassed': 'Deadline passed',
  'avcs.portfolio.next30': 'Next 30 days',
  'avcs.portfolio.clientGroup': 'Client group',
  'avcs.portfolio.allClientGroups': 'All client groups',
  'avcs.portfolio.onlyMine': 'Only my clients',
  'avcs.portfolio.onlyDeviations': 'Only deviations',
  'avcs.portfolio.moreFilters': 'More filters',
  'avcs.portfolio.emptyTitle': 'No clients in this period',
  'avcs.portfolio.emptyText': 'Either the firm has no active clients yet, or the period is before their takeover date. The takeover date is set per client under Clients.',
  'avcs.portfolio.clients': 'Clients',
  'avcs.portfolio.kpiDone': 'Fully reconciled',
  'avcs.portfolio.kpiWorking': 'In progress',
  'avcs.portfolio.kpiDeviations': 'With deviations',
  'avcs.portfolio.kpiLocked': 'Locked periods',
  'avcs.portfolio.kpiDue7': 'Deadlines in the next 7 days',
  'avcs.portfolio.showing': 'Showing: {filters}',
  'avcs.portfolio.openPointsIn': 'open points in {areas}',
  'avcs.portfolio.removeFilter': 'Remove filter',
  'avcs.nav.areaTitle': '{area}: {extra}',
  'avcs.nav.contextOnly': 'Context only: the area is not part of this review',
  'avcs.nav.summary': 'Summary',
  'avcs.nav.otherAreas': 'Other areas ({count})',
  'avcs.nav.otherAreasNote': 'These areas are not part of this review and are only shown as period context.',
  'avcs.nav.showMenu': 'Show menu',
  'avcs.nav.hideMenu': 'Hide menu',
  'avcs.header.backToReviewInbox': 'Back to the review inbox',
  'avcs.header.exportReviewBasis': 'Export review basis',
  'avcs.header.export': 'Export',
  'avcs.header.submitForReview': 'Send the whole period for review',
  'avcs.header.reopenPeriod': 'Reopen the period',
  'avcs.header.completePeriod': 'Complete period',
  'avcs.header.openRequests': '{count} open requests',
  'avcs.header.responsible': 'Responsible: {name}',
  'avcs.summary.noAccounts': 'No accounts',
  'avcs.summary.missingDocsShort': '{count} missing docs',
  'avcs.summary.openCount': '{count} open',
  'avcs.summary.colArea': 'Area',
  'avcs.summary.colCompleted': 'Completed',
  'avcs.summary.colMissing': 'Missing',
  'avcs.summary.noOpenDeviations': 'No open deviations.',
  'avcs.summary.noExternalBalance': 'No external balance entered',
  'avcs.summary.unexplained': 'Unexplained: {amount}',
  'avcs.summary.balanceChanged': 'Booked balance has changed since reconciliation',
  'avcs.summary.balanceChangedDetail': '{accounts}: the basis is not the same as when the account was reconciled.',
  'avcs.summary.reopenReconciliation': 'Reopen the reconciliation',
  'avcs.summary.progressByArea': 'Progress by area',
  'avcs.summary.openDeviations': 'Open deviations',
  'avcs.workspace.explanationSaved': 'The explanation has been saved on the period.',
  'avcs.workspace.conclusionSaved': 'The conclusion has been saved.',
  'avcs.workspace.reopenPrompt': 'Why is the period being reopened?',
  'avcs.workspace.sentToReview': 'Sent for review. Someone other than you must approve it.',
  'avcs.workspace.documentAttached': 'The document has been attached.',
  'avcs.workspace.removeConfirm': 'Remove "{file}"? Accounts that pointed to it are left without documentation.',
  'avcs.workspace.requestSent': 'The request has been sent to the client and saved on the period.',
  'avcs.workspace.requestSavedOnly': 'The request has been saved on the period. It was not placed in the client dialogue, so let them know another way.',
  'avcs.workspace.locked': 'The period is locked. Reopening requires a justification, which stays in the activity log.',
  'avcs.workspace.noAccountsTitle': 'No balance sheet accounts in this period',
  'avcs.workspace.noAccountsText': 'Reconciliation applies to the balance sheet accounts. If the client has not booked anything yet, there is nothing to reconcile.',
  'avcs.workspace.accountLabel': 'account {id}',
  'avcs.export.noAccounts': 'No accounts to export in this period.',
});
